<template>
  <div class="page-content homeworkPage">
    <!-- <div class="pageTitleBox d-flex d-flex-middle d-flex-between">
      <p class="pageTitle">助学培训费订单</p>
    </div> -->
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
        <span class="newMine_pageTitles">助学培训费订单（发票下载开放时间：工作日8:00至19:00）</span>
      </p>
    <div class="content">
      <div v-if="list.length == 0" class="empty-tip">暂无订单</div>
      <div v-else class="order-table-wrap">
        <table class="order-table">
          <thead>
            <tr>
              <th>费用类型</th>
              <th>金额</th>
              <th>订单编号</th>
              <th>创建时间</th>
              <th>状态</th>
              <th>支付时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td>{{ formatFeeType(item.yearTime) }}</td>
              <td>{{ item.money }}</td>
              <td>{{ item.orderNo || '--' }}</td>
              <td>{{ formatDate(item.createTime) }}</td>
              <td :class="getStatusClass(item)">{{ getStatusText(item) }}</td>
              <td>{{ formatPayTime(item) }}</td>
              <td class="action-cell">
                <div v-if="item.refundStatus == 0" class="action-list">
                  <a href="javascript:void(0)" class="action-link action-warning" @click="handleCancel(item.refundId)">撤回申请</a>
                </div>
                <div v-else class="action-list">
                  <span
                    v-if="item.refundStatus"
                    class="tag"
                    :class="item.refundStatus == 1 ? 'tag-success' : 'tag-danger'"
                  >{{ item.refundStatus == 1 ? '退费成功' : '退费失败' }}</span>
                  <span v-if="item.status === 'YZF' && Number(item.money) > 0" class="tag tag-success">已缴</span>
                  <a
                    v-if="item.orderId && item.status === 'YZF'"
                    href="javascript:void(0)"
                    class="action-link action-download"
                    @click="handleDownload(item.orderId)"
                  >下载发票</a>
                  <a
                    v-if="(item.status === 'WZF' || !item.status) && Number(item.money) > 0"
                    href="javascript:void(0)"
                    class="action-link action-primary"
                    @click="handlePay(item.orderId, item.yearTime)"
                  >去缴费</a>
                  <a
                    v-if="item.orderId && item.status === 'WZF'"
                    href="javascript:void(0)"
                    class="action-link action-secondary"
                    @click="handleRefresh(item.orderId)"
                  >刷新订单</a>
                  <span v-if="!hasOperation(item)" class="action-empty">--</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="form.size"
        :total="total"
        @current-change="changePage"
      >
      </el-pagination>
    </div>

    <el-dialog title="申请退费" :visible.sync="dialogFormVisible">
      <el-form :model="refundForm" :rules="rules" ref="ruleForm">
        <el-form-item label="申请原因" prop="remark">
          <el-input v-model="refundForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="resetForm('ruleForm')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <PayDialog ref="payDialog" @refresh="getData" />

  </div>
</template>

<script>
import PayDialog from '@/components/bm/PayDialog.vue'

export default {
  components: {
    PayDialog
  },
  data() {
    return {
      studentInfo:{},
      list: [],
      form:{
        size: 10,
        current: 1,
      },
      total:0,
      orders: [],
      dialogFormVisible: false,
      refundForm: {
        id: '',
        remark: '',
      },
    rules: {
      remark: [
        { required: true, message: '请输入申请原因', trigger: 'blur' },
      ],
    }
  };
},
created() {
  this.loadStudentInfo()
},
  async mounted() {
    this.getData()
  },
  methods: {
    formatFeeType(yearTime) {
      const yearNames = ['', '一', '二', '三', '四', '五']
      const n = Number(yearTime)
      if (!n) return '--'
      return `第${yearNames[n] || n}年学费`
    },
    formatDate(time) {
      if (!time) return '--'
      return String(time).substring(0, 10)
    },
    formatPayTime(item) {
      if (item.status !== 'YZF' || Number(item.money) === 0) return '--'
      if (!item.payTime) return '--'
      return item.payTime
    },
    getStatusText(item) {
      if (Number(item.money) === 0) return '--'
      if (item.status === 'YZF') return '已支付'
      if (item.status === 'WZF' || !item.status) return '待支付'
      return '--'
    },
    getStatusClass(item) {
      if (Number(item.money) === 0) return 'status-empty'
      if (item.status === 'YZF') return 'status-paid'
      if (item.status === 'WZF' || !item.status) return 'status-pending'
      return 'status-empty'
    },
    hasOperation(item) {
      if (item.refundStatus) return true
      if (item.status === 'YZF' && Number(item.money) > 0) return true
      if (item.orderId && item.status === 'YZF') return true
      if ((item.status === 'WZF' || !item.status) && Number(item.money) > 0) return true
      if (item.orderId && item.status === 'WZF') return true
      return false
    },
    loadStudentInfo() {
      this.$http.get('/student/pc/getStudentInfo').then(res => {
        console.log(res);
        this.studentInfo = res
      })
    },
    handleDownload(orderId) {
      this.$http
        .get(`/student/pc/getInvoice/${orderId}`)
        .then((url) => {
          if (url) {
            window.open(url)
          }
        })
        .catch(() => {})
    },
    handleBack(id) {
      this.dialogFormVisible = true
      this.refundForm.id = id
    },
    handleCancel(id) {
      let _this = this
      this.$confirm('确定撤回申请吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get('/student/pc/order/refund/remove/' + id).then((res) => {
          this.$message({
            type: 'success',
            message: '撤回成功!'
          });
          _this.getData()
        })
      })
    },
    async getData() {
      this.$http.get('/student/pc/order/myOrders',this.form).then((res) => {
        this.list = res.records
        this.total = res.total
      })
    },
    changePage(e){
      this.form.current = e
      this.getData();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.get('/student/pc/order/refund/apply',this.refundForm).then((res) => {
            this.getData()
            this.$message({
              type: 'success',
              message: '申请成功!'
            });
            this.resetForm('ruleForm')
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false
    },
    detail(row){
      this.$router.push('/paperDetail?type=HOMEWORK&id='+row.paperId+'&examDataId='+row.examDataId+'&myScore='+row.score+'&examConfigId='+this.form.examConfigId)
    },
    handlePay(orderId, feeType) {
      if (orderId) {
        // 如果已有订单ID，获取订单详情
        this.$http.get('/student/pc/studyFee/order/getDetail/' + orderId).then(res => {
          // 将订单详情传递给PayDialog组件
          this.$refs.payDialog.open({
            id: res.id,
            orderNo: res.orderNo,
            cost: res.cost || res.money,
            yearTime: res.yearTime,
            createTime: res.createTime
          })
        })
      } else {
        // 如果没有订单ID，创建新订单
        this.$http.post('/student/pc/studyFee/order/create2/' + feeType,{
          studentId: this.studentInfo.id
        }).then(res => {
          // 将订单详情传递给PayDialog组件
          this.$refs.payDialog.open({
            id: res.id,
            orderNo: res.orderNo,
            cost: res.cost || res.money,
            yearTime: res.yearTime,
            createTime: res.createTime
          })
        })
      }
    },
    handleRefresh(orderId) {
        this.$http.get('/student/pc/isPaid', {
          id:orderId,
          studentId: this.studentInfo.id
        }).then((res) => {
          if (res == 'true' || res === true) {
            this.$message({
              type: 'success',
              message: '刷新成功!'
            });
            this.getData()
          }
        })
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";

.homeworkPage {
  .content {
    box-sizing: border-box;
    padding: 0 30px;
    min-height: 450px;
  }

  .empty-tip {
    text-align: center;
    color: #999;
    font-size: 14px;
    padding: 40px 0;
  }

  .order-table-wrap {
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
  }

  .order-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    color: #333;

    th,
    td {
      padding: 14px 12px;
      text-align: center;
      border: 1px solid #e8e8e8;
      vertical-align: middle;
    }

    thead {
      background: #f5f7fa;

      th {
        font-weight: normal;
        color: #333;
      }
    }

    tbody {
      tr {
        background: #fff;
      }

      .status-paid {
        color: #52c41a;
      }

      .status-pending {
        color: #fa8c16;
      }

      .status-empty {
        color: #999;
      }
    }
  }

  .action-cell {
    .action-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }

    .tag {
      display: inline-block;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      line-height: 20px;
      white-space: nowrap;
    }

    .tag-success {
      color: #52c41a;
      background: #f6ffed;
      border: 1px solid #b7eb8f;
    }

    .tag-danger {
      color: #ff4d4f;
      background: #fff2f0;
      border: 1px solid #ffccc7;
    }

    .action-link {
      font-size: 14px;
      cursor: pointer;
      text-decoration: none;
      white-space: nowrap;

      &.action-primary {
        color: #1890ff;
        text-decoration: underline;

        &:hover {
          color: #40a9ff;
        }
      }

      &.action-download {
        color: #13c2c2;

        &:hover {
          color: #36cfc9;
          text-decoration: underline;
        }
      }

      &.action-secondary {
        color: #999;

        &:hover {
          color: #666;
          text-decoration: underline;
        }
      }

      &.action-warning {
        color: #ff4d4f;
        text-decoration: underline;

        &:hover {
          color: #ff7875;
        }
      }
    }

    .action-empty {
      color: #999;
      font-size: 14px;
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 20px;
  }
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

</style>
